




































import { Component, Vue, Prop } from 'vue-property-decorator'
import AreaModal from '@/components/areaModal/index.vue'
@Component({
  components: {
    AreaModal
  }
})
export default class FreeShipping extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {
      return {
        discountType: '满X元包邮',
        value: null,
        province: [],
        memberScope: 'All',
        cumulativeWithOtherDiscount: false
      }
    }
  })
  value!: any
  areaChange(e) {
    console.log(e)
    this.value.province = e
  }
  removeArea(index: number) {
    this.value.province.splice(index, 1)
  }
  get unit() {
    return this.value.discountType === '满X元包邮' ? '元' : '件'
  }
}
